import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getRecognizeAudienceInsights } from "./get-recognize-audience-insights";
import { getRecognizeExportCount } from "./get-recognize-export-count";
import { getRecognizeVips } from "./get-recognize-vips";
import {
  getRecognizeActions,
  saveRecognizeActions,
  sendRecognizeTestEmail,
} from "./recognize-actions";
import {
  getRecognizeRunFilters,
  getRecognizeSalesChannels,
  saveRecognizeRunFilters,
} from "./recognize-run-filters";

export const recognizeRpcDefinition = {
  getRecognizeRunFilters,
  getRecognizeSalesChannels,
  saveRecognizeRunFilters,
  getRecognizeActions,
  saveRecognizeActions,
  sendRecognizeTestEmail,
  getRecognizeAudienceInsights,
  getRecognizeExportCount,
  getRecognizeVips,
};

export type RecognizeRpcDefinition = InferRpcDefinition<
  typeof recognizeRpcDefinition
>;
